export default __webpack_public_path__ + "static/careers-benefits-block1-icon03.url-c4fc3a30e4d893292eb7e1d21c9e92ed.svg";